<template>
  <div class="gallery-slide">
    <div class="content-block__swiper__slide">
      <div
        v-if="item.portrait.length"
        class="content-block__swiper__slide__image"
      >
        <WidgetPicture
          :image="{
            portrait: item.portrait?.[0],
          }"
          :alt="item.portrait?.[0]?.title"
        />
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  item: {
    type: Object,
    default: () => ({}),
  },
})
</script>

<script>
export default {
  name: 'GallerySlide',
}
</script>

<style lang="scss">
@import './style.scss';
</style>
